export default __webpack_public_path__ + "static/media/electrical-systems.88da5535.svg";